import { render, staticRenderFns } from "./CmgOffers.vue?vue&type=template&id=7c6fbdaf&scoped=true&lang=pug"
import script from "./cmg-offers.ts?vue&type=script&lang=ts&external"
export * from "./cmg-offers.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOffers.vue?vue&type=style&index=0&id=7c6fbdaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6fbdaf",
  null
  
)

export default component.exports